/* Small UI behaviours without jQuery: accordions and the science result tabs.

   Part 1: accordions.

   CHANGED: six places used the same jQuery pattern, bound at DOMContentLoaded:
     $(".open").not(this).removeClass("open").next().slideUp(300).parent().removeClass("active");
     $(this).toggleClass("open").next().slideToggle(300).parent().toggleClass("active");
   theme.liquid (.faqs-title), Faqs (.faq-block.is-title), Creative_Faq
   (.accordian-title-wrap), Counter_section (.mobileaccordian .counter-text, phones only),
   footer-new and footer-skin-new (.tres, phones only, no .active on the parent).
   This file reproduces that behaviour exactly, including the page-wide "close every other
   .open item" rule, with a 300ms ease-in-out height and padding slide like jQuery's
   slideUp/slideDown, and does it through one delegated click listener so items inside a
   re-rendered product section keep working. It is the only reason jQuery had to load on
   most pages. */
(function () {
  'use strict';
  var DURATION = 300;

  function finish(el) {
    ['height', 'padding-top', 'padding-bottom', 'overflow', 'transition'].forEach(function (p) { el.style.removeProperty(p); });
  }

  function slideUp(el) {
    if (getComputedStyle(el).display === 'none') return;
    var cs = getComputedStyle(el);
    el.style.height = el.offsetHeight + 'px';
    el.style.paddingTop = cs.paddingTop;
    el.style.paddingBottom = cs.paddingBottom;
    el.style.overflow = 'hidden';
    void el.offsetHeight;
    el.style.transition = 'height ' + DURATION + 'ms ease-in-out, padding-top ' + DURATION + 'ms ease-in-out, padding-bottom ' + DURATION + 'ms ease-in-out';
    el.style.height = '0px';
    el.style.paddingTop = '0px';
    el.style.paddingBottom = '0px';
    clearTimeout(el._slideTimer);
    el._slideTimer = setTimeout(function () { el.style.display = 'none'; finish(el); }, DURATION);
  }

  function slideDown(el) {
    el.style.removeProperty('display');
    var display = getComputedStyle(el).display;
    if (display === 'none') { display = 'block'; el.style.display = display; }
    var cs = getComputedStyle(el);
    var height = el.offsetHeight, pt = cs.paddingTop, pb = cs.paddingBottom;
    el.style.overflow = 'hidden';
    el.style.height = '0px';
    el.style.paddingTop = '0px';
    el.style.paddingBottom = '0px';
    void el.offsetHeight;
    el.style.transition = 'height ' + DURATION + 'ms ease-in-out, padding-top ' + DURATION + 'ms ease-in-out, padding-bottom ' + DURATION + 'ms ease-in-out';
    el.style.height = height + 'px';
    el.style.paddingTop = pt;
    el.style.paddingBottom = pb;
    clearTimeout(el._slideTimer);
    el._slideTimer = setTimeout(function () { finish(el); }, DURATION);
  }

  function slideToggle(el) {
    if (getComputedStyle(el).display === 'none') slideDown(el); else slideUp(el);
  }

  window.yhlSlideUp = slideUp;
  window.yhlSlideDown = slideDown;
  window.yhlSlideToggle = slideToggle;

  /* selector, toggle .active on the parent, media query that must match */
  var GROUPS = [
    ['.faqs-title', true, null],
    ['.faq-block.is-title', true, null],
    ['.accordian-title-wrap', true, null],
    ['.mobileaccordian .counter-text', true, '(max-width: 768px)'],
    ['.tres', false, '(max-width: 768px)']
  ];

  function toggle(title, parentActive) {
    document.querySelectorAll('.open').forEach(function (other) {
      if (other === title) return;
      other.classList.remove('open');
      var panel = other.nextElementSibling;
      if (panel) slideUp(panel);
      if (parentActive && other.parentElement) other.parentElement.classList.remove('active');
    });
    title.classList.toggle('open');
    var panel = title.nextElementSibling;
    if (panel) slideToggle(panel);
    if (parentActive && title.parentElement) title.parentElement.classList.toggle('active');
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    for (var i = 0; i < GROUPS.length; i++) {
      var title = e.target.closest(GROUPS[i][0]);
      if (!title) continue;
      if (GROUPS[i][2] && !window.matchMedia(GROUPS[i][2]).matches) return;
      toggle(title, GROUPS[i][1]);
      return;
    }
  });

  /* Part 2: science result tabs.
     CHANGED: Science_common, Scientific_Result and Scicollagen each bound the same jQuery
     handler on .result-tabs .tab: read data-id, then move is-active across every .tab,
     .result-img and .result-content on the page whose class carries is-<id>. The gsap.set
     call that preceded it has been a no-op since GSAP was removed (the stub in
     animation.js), so it is not reproduced. Delegated from document, same page-wide scope. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var tab = e.target.closest('.result-tabs .tab');
    if (!tab) return;
    var id = tab.getAttribute('data-id');
    if (id === null) return;
    ['.tab', '.result-img', '.result-content'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { el.classList.remove('is-active'); });
      document.querySelectorAll(sel + '.is-' + id).forEach(function (el) { el.classList.add('is-active'); });
    });
  });
})();
